export const DNR_LANDING_PAGE = 'DNR_LANDING_PAGE';
export const DNR_HOSPITAL_PROFILE_PAGE_DATA = 'DNR_HOSPITAL_PROFILE_PAGE_DATA';
export const DNR_HOSPITAL_RECOMENDED_POST_DATA = 'DNR_HOSPITAL_RECOMENDED_POST_DATA';
export const DNR_HOSPITAL_GET_ALL_ACTIVITIES_DATA = 'DNR_HOSPITAL_GET_ALL_ACTIVITIES_DATA';
